import { render } from "./MoreActionsBtn.vue?vue&type=template&id=c082748a"
import script from "./MoreActionsBtn.vue?vue&type=script&lang=js"
export * from "./MoreActionsBtn.vue?vue&type=script&lang=js"

import "./MoreActionsBtn.vue?vue&type=style&index=0&id=c082748a&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__